<div class="centered-dialog">
    <form>
        <section>
            <je-list (selectionChanged)="onSelectionChanged($event)" [items]="roles$ | async" label="{{ 'USERROLESELECTION.USERROLESELECTIONLABEL' | translate }}">
                <ng-template let-role>
                    <div class="p-2 rounded text-black-900 dark:text-gray-300 border border-solid border-black-500 text-left hover:bg-blue hover:text-white">
                        {{ role.description }}
                    </div>
                </ng-template>
            </je-list>
        </section>
    </form>
</div>
